import React, { useCallback } from 'react';

import { Can } from '@vlabs/shared/components/can/Can';
import { EmptyCard } from '@vlabs/shared/components/empty-card';
import { permissions } from '@vlabs/shared/config';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { EventTopMatchCell } from './EventTopMatchCell';
import { FaceTopMatchCell } from './FaceTopMatchCell';
import st from './TopMatchCell.module.sass';

export const TopMatchCell = ({
  topMatch,
  original,
  onTopMatchCardClick,
}) => {
  const { t } = useTranslation();
  const originalDetections = {
    hasBody: !!original?.body_detections,
    hasFace: !!original?.face_detections,
  };

  const clickHandler = useCallback((e) => {
    if (!onTopMatchCardClick) return;
    if (e.code === 'Enter' || e.code === undefined) {
      onTopMatchCardClick(e);
    }
  }, [onTopMatchCardClick]);

  if (!topMatch) {
    return (
      <div className={st.EmptyCard}>
        <EmptyCard dataTip={t('no data.tooltip no matches')} text={t('no data.title')} />
      </div>
    );
  }

  return (
    <div className={st.Root} data-testid="topMatchCell">
      {topMatch?.face_id && (
        <Can
          no={<EmptyCard text={t('events:недостаточно прав для просмотра лиц')} />}
          permissions={{ rules: [permissions.face.view] }}
          yes={(
            <FaceTopMatchCell
              onClick={clickHandler}
              originalDetections={originalDetections}
              topMatch={topMatch}
            />
          )}
        />
      )}
      {topMatch?.event_id && (
        <EventTopMatchCell
          onClick={onTopMatchCardClick}
          originalDetections={originalDetections}
          topMatch={topMatch}
        />
      )}
    </div>
  );
};

TopMatchCell.propTypes = {
  topMatch: PropTypes.object,
  original: PropTypes.object,
  onTopMatchCardClick: PropTypes.func,
};

TopMatchCell.defaultProps = {
  topMatch: undefined,
  original: undefined,
  onTopMatchCardClick: undefined,
};
